import { c as _c } from "react/compiler-runtime";
type IconProps = {
  className?: string;
};
export function FullscreenIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M27.9999 13.2686C27.9999 13.9814 27.1382 14.3383 26.6342 13.8343L23.4752 10.6752L10.6752 23.4752L13.8343 26.6342C14.3383 27.1382 13.9814 27.9999 13.2686 27.9999H4.8C4.35817 27.9999 4 27.6417 4 27.1999V18.7313C4 18.0186 4.86171 17.6616 5.36569 18.1656L8.4125 21.2124L21.2124 8.41251L18.1656 5.36568C17.6616 4.86171 18.0186 4 18.7313 4H27.1999C27.6417 4 27.9999 4.35817 27.9999 4.8V13.2686Z" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function FullscreenExitIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M28.3313 3.66806C27.7062 3.04294 26.6927 3.04294 26.0676 3.66806L21.3966 8.33901L18.1606 5.10308C17.6564 4.59888 16.7943 4.95597 16.7943 5.66902V14.1415C16.7943 14.5835 17.1526 14.9418 17.5947 14.9418H26.0672C26.7803 14.9418 27.1373 14.0797 26.6331 13.5755L23.6604 10.6028L28.3313 5.93183C28.9565 5.3067 28.9565 4.29318 28.3313 3.66806Z" fill="currentColor" />;
    t2 = <path d="M13.8272 26.3813C14.3315 26.8855 15.1936 26.5284 15.1936 25.8154V17.3429C15.1936 16.9009 14.8352 16.5426 14.3932 16.5426H5.92067C5.20762 16.5426 4.85052 17.4047 5.35472 17.9089L8.59079 21.1449L3.66904 26.0666C3.04391 26.6917 3.04391 27.7053 3.66904 28.3304C4.29417 28.9555 5.3077 28.9555 5.93282 28.3304L10.8546 23.4087L13.8272 26.3813Z" fill="currentColor" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}